export default __webpack_public_path__ + "static/media/best.35ba9142.jpg";